import { User } from "../models";

export function hasPermission(user: User, permissionId: number | number[]): boolean {

  if (Array.isArray(permissionId)) {
    let authorized: boolean = false;
    permissionId.forEach(pid => {
      if (user?.permissions?.find(p => p.id === pid)) {
        authorized = true;
      }
    });
    return authorized;
  }

  return !!user?.permissions?.find(p => p.id === permissionId);
}
